import {faLibrary, FontAwesomeIcon as fai} from '@literacyplanet/client_core';

import {faPercent} from '@fortawesome/pro-solid-svg-icons/faPercent';
import {faTrophy} from '@fortawesome/pro-solid-svg-icons/faTrophy';
import {faXmark} from '@fortawesome/pro-solid-svg-icons/faXmark';
import {faXmark as faXmarkRegular} from '@fortawesome/pro-regular-svg-icons/faXmark';

faLibrary.add([
  faPercent,
  faTrophy,
  faXmark,
  faXmarkRegular
]);
export const FontAwesomeIcon = fai;
